import { Menu } from "antd";
import React from "react";
import { BankFeedAccount } from "../constants";
import { DropdownContents } from "./DropdownContents";
import { DropdownWrapper } from "./DropdownWrapper";

export const DropdownLinked = React.memo(
  ({
    bfAccount,
    glAccountDropdownLabel,
  }: {
    bfAccount: BankFeedAccount;
    glAccountDropdownLabel: string;
  }) => {
    return (
      <DropdownWrapper visible={true}>
        <DropdownContents
          overlay={<Menu></Menu>}
          disabled={true}
          bfAccountId={bfAccount.id}
          onVisibleChange={(_visible: boolean) => {}}
          glAccountDropdownLabel={glAccountDropdownLabel}
        />
      </DropdownWrapper>
    );
  },
);
